import React, { FC, useEffect, useRef } from 'react';
import { SearchInputSmall } from '../common/SearchInputSmall';
import { ButtonComponent } from '../ButtonComponent';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { makeSearchParams, parseSearchParams } from '../../utils/utilities';
import { useLocation } from 'react-router';
import { useDebounce } from 'use-debounce';

interface Props {
  query: string;
  setQuery: (value: string) => void;
  setIsAddAgencyModalOpen: (value: boolean) => void;
}
export const SalesAgenciesListFilters: FC<Props> = (props) => {
  const { query, setQuery, setIsAddAgencyModalOpen } = props;

  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  const [value] = useDebounce(query.trim(), 1000);


  const filtersFromUrl = parseSearchParams(search) || {};

  useEffect(() => {
    if (!isMounted.current) return;

    const params = filtersFromUrl;
    params.query = query;

    navigate(`${pathname}?${makeSearchParams(params)}`);
  }, [value]);

  useEffect(() => {
    if (!isMounted.current) {
      // first mount
      isMounted.current = true;
    }
  }, []);

  return (
    <div className="card bg-transparent mb-5 mb-xl-8">
      <div className="card-body px-0 py-0 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center block-width application-selector">

          <SearchInputSmall
            placeholder={t('AGENCY.SEARCH_PLACEHOLDER')}
            searchValue={query}
            setSearchValue={setQuery}
          />

        </div>
        <div>
          <ButtonComponent
            buttonName={t('AGENCY.BTN_NAME')}
            onButtonClick={(): void => setIsAddAgencyModalOpen(true)}
            additionalClass="btn-sm"
          />
        </div>
      </div>
    </div>
  );
};